export default __webpack_public_path__ + "static/media/menu-about.21da447d.jpg";